import React, { useEffect, useRef, useState } from "react";
import { HomeHeader } from "../../../components/headers/HomeHeader"; // adjust if needed

const HOME_HEADER_HEIGHT = 79; // match your HomeHeader height if different

export const HighSeverityPotentialClaims = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const tagRef = useRef(null);
  const dropdownRef = useRef(null);
  const year = new Date().getFullYear();

  // Close dropdown on outside click
  useEffect(() => {
    const onClickAway = (e) => {
      if (!menuOpen) return;
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target) &&
        tagRef.current &&
        !tagRef.current.contains(e.target)
      ) {
        setMenuOpen(false);
      }
    };
    window.addEventListener("click", onClickAway);
    return () => window.removeEventListener("click", onClickAway);
  }, [menuOpen]);

  return (
    <div>
      <HomeHeader headerColor="#0D131E" textColor="#ffffff" />

      {/* Scoped styles (all classes prefixed with .hspc-) */}
      <style>{`
        li {
          padding-top:10px;
          padding-bottom:0px;
        }

        .hspc-root {
          --bg: #0a0c10;
          --panel: #0f131a;
          --panel-2: #121722;
          --text: #e6e9ef;
          --muted: #a7b0c0;
          --brand: #0b5cff;
          --brand-2: #8ab4ff;
          --ok: #1fbf75;
          --warn: #ffd166;
          --danger: #ff5d5d;
          --card-radius: 18px;
          --shadow: 0 10px 30px rgba(0,0,0,.35);
          --maxw: 1100px;
          --offset: ${HOME_HEADER_HEIGHT}px;

          color: var(--text);
          background:
            radial-gradient(1200px 800px at 10% -10%, rgba(11,92,255,.15), transparent 60%),
            radial-gradient(1200px 800px at 110% 10%, rgba(138,180,255,.1), transparent 60%),
            var(--bg);
          line-height: 1.55;
          font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, "Apple Color Emoji", "Segoe UI Emoji";
          text-align: left; /* don't inherit center alignment */
          letter-spacing: normal;
        }

        .hspc-container { max-width: var(--maxw); margin: 0 auto; padding: 24px; }

        /* Sticky page header sits below HomeHeader */
        .hspc-header {
          position: sticky;
          top: var(--offset);
          z-index: 50;
          backdrop-filter: saturate(140%) blur(10px);
          background: linear-gradient(180deg, rgba(10,12,16,.9), rgba(10,12,16,.6));
          border-bottom: 1px solid rgba(255,255,255,.06);
        }
        .hspc-nav { display:flex; align-items:center; justify-content:space-between; gap:16px; }
        .hspc-logo { display:flex; align-items:center; gap:12px; text-decoration:none; color:var(--text); }
        .hspc-mark { width:28px; height:28px; display:grid; place-items:center; border-radius:8px; background:linear-gradient(135deg, var(--brand), #2b90ff); box-shadow: var(--shadow); }
        .hspc-word { font-weight:700; letter-spacing:.2px; }

        .hspc-cta { display:flex; gap:10px; }
        .hspc-btn {
          --padx: 14px; --pady: 10px;
          padding: var(--pady) var(--padx);
          border-radius: 999px;
          border: 1px solid rgba(255,255,255,.12);
          color: var(--text);
          text-decoration: none;
          font-weight: 600; font-size: 14px;
          transition: transform .06s ease, background .2s ease, border-color .2s ease;
        }
        .hspc-btn:hover { transform: translateY(-1px); }
        .hspc-btn.primary { background: linear-gradient(135deg, var(--brand), #2b90ff); border-color: transparent; }
        .hspc-btn.ghost { background: rgba(255,255,255,.03); }

        .hspc-hero { padding: 56px 0 26px; position: relative; }
        .hspc-hero h1 { font-size: clamp(34px, 3.8vw, 48px); line-height: 1.12; margin: 0 0 16px; letter-spacing: .3px; word-spacing: .4px; }
        .hspc-hero p { color: var(--muted); font-size: clamp(16px, 1.7vw, 18px); max-width: 880px; }
        .hspc-tag {
          display:inline-flex; align-items:center; gap:8px; padding:6px 12px;
          border-radius:999px; background: rgba(11,92,255,.12);
          color:#cfe0ff; border:1px solid rgba(138,180,255,.25);
          font-weight:600; font-size:13px; cursor:pointer;
        }

        .hspc-grid { display:grid; gap:18px; }
        .hspc-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }
        .hspc-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
        @media (max-width: 900px) {
          .hspc-cols-3, .hspc-cols-2 { grid-template-columns: 1fr; }
        }

        .hspc-card { background: linear-gradient(180deg, var(--panel), var(--panel-2)); border:1px solid rgba(255,255,255,.06); border-radius: var(--card-radius); box-shadow: var(--shadow); padding: 20px 18px; }
        .hspc-card h3 { margin: 0 0 8px; font-size: 18px; }
        .hspc-card p { margin: 0; color: var(--muted); }

        .hspc-kv { display:flex; gap:12px; align-items:flex-start; padding:14px 0; border-top:1px dashed rgba(255,255,255,.08); }
        .hspc-kv:first-child { border-top: 0; }
        .hspc-k { flex: 0 0 160px; color:#cfe0ff; font-weight:700; text-transform:uppercase; letter-spacing:.6px; font-size:12px; }
        .hspc-v { flex: 1; color: var(--text); }

        .hspc-badges { display:flex; gap:8px; flex-wrap:wrap; }
        .hspc-badge { display:inline-flex; align-items:center; gap:8px; padding:8px 12px; border-radius:12px; background: rgba(255,255,255,.04); border:1px solid rgba(255,255,255,.08); font-weight:600; color: var(--text); }

        .hspc-section { margin: 30px 0; }
        .hspc-section h2 { font-size:22px; margin:0 0 8px; }
        .hspc-muted { color: var(--muted); }

        .hspc-headline { display:flex; align-items:center; gap:12px; margin:28px 0 10px; }
        .hspc-rule { height:1px; background: linear-gradient(90deg, rgba(255,255,255,0), rgba(255,255,255,.2), rgba(255,255,255,0)); flex:1; }

        .hspc-callout { border-left:3px solid var(--brand); background: rgba(11,92,255,.08); padding:14px 16px; border-radius:10px; }

        .hspc-metrics { display:grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap:12px; margin-top:12px; }
        .hspc-metric { text-align:center; padding:16px; border-radius:14px; background: rgba(255,255,255,.04); border:1px solid rgba(255,255,255,.08); }
        .hspc-metric h4 { margin:0 0 4px; font-size:20px; }
        .hspc-metric p { margin:0; color: var(--muted); font-size:14px; }
        @media (max-width: 1000px) { .hspc-metrics { grid-template-columns: 1fr 1fr; } }
        @media (max-width: 700px) { .hspc-metrics { grid-template-columns: 1fr; } }

        .hspc-footer { margin: 40px 0 20px; color: var(--muted); font-size: 13px; text-align: center; }

        /* Dropdown menu */
        .hspc-menu {
          position:absolute;
          background-color:#0f131a;
          min-width:260px;
          z-index:10;
          border-radius:10px;
          box-shadow: var(--shadow);
          border:1px solid rgba(255,255,255,.12);
          margin-top:8px;
        }
        .hspc-menu a { color: var(--text); padding: 12px; text-decoration:none; display:block; }
        .hspc-menu a:hover { background-color: var(--brand-2); }

        @media print {
          .hspc-header { display:none; }
          .hspc-root { background:#fff; color:#111; }
          .hspc-card { background:#fff; border-color:#ddd; box-shadow:none; }
          .hspc-hero .hspc-tag { background:#e9f1ff; color:#0b5cff; border-color:#c9ddff; }
        }
      `}</style>

      <div className="hspc-root">
        {/* Page header (sticks below HomeHeader) */}
        <header className="hspc-header">
          <div className="hspc-container hspc-nav">
            <a
              className="hspc-logo"
              href="#top"
              aria-label="Charlee.ai — High Severity Potential Claims"
            >
              <span className="hspc-mark" aria-hidden="true">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  focusable="false"
                >
                  <path
                    d="M12 2l2.2 5.7L20 10l-5.8 2.3L12 18l-2.2-5.7L4 10l5.8-2.3L12 2z"
                    fill="white"
                    opacity=".9"
                  />
                </svg>
              </span>
              <span className="hspc-word">Charlee.ai</span>
            </a>
            <div className="hspc-cta">
              <a className="hspc-btn ghost" href="#value">
                Value
              </a>
              <a className="hspc-btn ghost" href="#financial-impact">
                Financial Impact
              </a>
              <a className="hspc-btn primary" href="#product">
                Product
              </a>
            </div>
          </div>
        </header>

        <main className="hspc-container" style={{ paddingTop: "70px" }}>
          <section className="hspc-hero">
            {/* Dropdown trigger */}
            <span
              ref={tagRef}
              className="hspc-tag"
              onClick={() => setMenuOpen((v) => !v)}
              aria-haspopup="true"
              aria-expanded={menuOpen}
              role="button"
            >
              Use Case 4 · High Severity Potential Claims{" "}
              <span aria-hidden="true">▼</span>
            </span>

            {/* Dropdown menu (SEO-friendly anchors) */}
            <div
              ref={dropdownRef}
              className="hspc-menu"
              style={{ display: menuOpen ? "block" : "none" }}
            >
              {/* Point these to your app's routes for internal navigation */}
              <a href="/usecase/large-loss-alerts">
                Use Case 1 · Large Loss Alerts
              </a>
              <a href="/usecase/early-severity-signal-detection">
                Use Case 2 · Early Severity Signal Detection
              </a>
              <a href="/usecase/reserve-adequacy-monitoring">
                Use Case 3 · Reserve Adequacy Monitoring (Incurred Below
                Prediction)
              </a>
              <a href="/usecase/high-severity-potential-claims">
                Use Case 4 · High Severity Potential Claims
              </a>
              <a href="/usecase/proactive-severity-litigation-intelligence">
                Use Case 5 · Proactive Severity & Litigation Intelligence
              </a>
              <a href="/usecase/intelligent-claims-document-summarization">
                Use Case 6 · Intelligent Claims Document Summarization
              </a>
            </div>

            <h1 style={{ fontWeight: "bold" }}>
              Catch High-Severity Potential Early <br />— With Context You Can
              Act On
            </h1>
            <p>
              Bodily injury claims can escalate quickly—what starts as a routine
              case can become high severity within hours. Early attorney
              involvement, unexpected treatment progression, and prolonged
              recovery timelines can drive inflated reserves, higher payouts,
              and extended claim cycle times. For insurers, early identification
              of severity risk is critical to controlling outcomes and improving
              claimant experience.
            </p>
            <br />
            <p className="hspc-muted">
              <strong>4SeeCharlee</strong> brings AI-driven severity assessment
              to the frontlines. It continuously monitors structured data (e.g.,
              injury codes, treatment types) and unstructured inputs (adjuster
              notes, medical records, demand packages) to detect signs of
              high-severity potential early. More than just a score, Charlee
              provides contextual insights—flagging why a claim is escalating
              and helping teams prioritize triage, allocate resources, and avoid
              costly delays. These severity-scored claims integrate seamlessly
              into existing workflows via APIs and Charlee AI Agents, with no
              disruption to claims operations.
            </p>
          </section>

          <section className="hspc-grid hspc-cols-3">
            <div className="hspc-card">
              <h3 style={{ fontWeight: "bold" }}>Role</h3>
              <p>Senior Claims Adjuster, Supervisor, Manager</p>
            </div>
            <div className="hspc-card">
              <h3 style={{ fontWeight: "bold" }}>Job at Hand</h3>
              <p>Prioritize high-risk cases early for better handling</p>
            </div>
            <div className="hspc-card">
              <h3 style={{ fontWeight: "bold" }}>Trigger</h3>
              <p>
                Spike in bodily injury claims following accident surge or
                catastrophic event
              </p>
            </div>
          </section>

          <section className="hspc-section">
            <div className="hspc-headline">
              <h2 style={{ margin: 0, fontWeight: "bold" }}>Opportunity</h2>
              <div className="hspc-rule" />
            </div>
            <div className="hspc-card">
              <p>
                Early identification of severe claims improves outcomes, reduces
                costs, and enhances claimant satisfaction.
              </p>
            </div>
          </section>

          <section className="hspc-grid hspc-cols-2 hspc-section">
            <div className="hspc-card">
              <h3 style={{ fontWeight: "bold" }}>Before Charlee</h3>
              <p>
                Severity identification relied on adjuster judgment,
                inconsistent documentation, and subjective triage processes.
              </p>
            </div>
            <div className="hspc-card">
              <h3 id="product" style={{ fontWeight: "bold" }}>
                With Charlee
              </h3>
              <p>
                AI continuously analyzes medical indicators, claim narratives,
                and historical risk patterns to flag high-severity potential
                cases and surface them for early intervention.
              </p>
            </div>
          </section>

          <section className="hspc-section">
            <div className="hspc-grid hspc-cols-3">
              <div className="hspc-card">
                <h3 style={{ fontWeight: "bold" }}>Product Used</h3>
                <div className="hspc-badges">
                  <span className="hspc-badge">🔎 4SeeCharlee</span>
                </div>
              </div>
              <div className="hspc-card">
                <h3 style={{ fontWeight: "bold" }}>LOBs</h3>
                <div className="hspc-badges">
                  <span className="hspc-badge">All</span>
                </div>
              </div>
              <div className="hspc-card" id="financial-impact">
                <h3 style={{ fontWeight: "bold" }}>Area</h3>
                <div className="hspc-badges">
                  <span className="hspc-badge">Claims</span>
                  <span className="hspc-badge">Severity</span>
                </div>
              </div>
            </div>
          </section>

          <section className="hspc-section">
            <div className="hspc-headline">
              <h2 style={{ margin: 0, fontWeight: "bold" }}>
                Financial Impact
              </h2>
              <div className="hspc-rule" />
            </div>
            <div className="hspc-card">
              <p className="hspc-muted">
                Delayed identification of high-severity claims often results in:
              </p>
              <ul style={{ listStyleType: "disc", paddingLeft: "50px" }}>
                <li>
                  Inflated settlements due to late medical management or missed
                  negotiation windows
                </li>
                <li>
                  Higher legal costs, as delayed intervention increases the
                  likelihood of attorney involvement
                </li>
                <li>
                  Claimant dissatisfaction, leading to complaints and
                  reputational risk
                </li>
              </ul>
              <div className="hspc-callout" style={{ marginTop: 12 }}>
                <strong>Charlee delivers measurable financial value:</strong>
                <ul style={{ listStyleType: "disc", paddingLeft: "50px" }}>
                  <li>
                    $7K–$18K estimated savings per high-severity claim through
                    early triage and avoidance of escalation
                  </li>
                  <li>
                    Reduction in unnecessary specialist assignments and
                    over-reserving
                  </li>
                  <li>
                    Shorter claim durations and faster resolutions, boosting
                    operational efficiency and satisfaction
                  </li>
                  <li>
                    Reduced late-stage litigation, reserve leakage, and customer
                    dissatisfaction
                  </li>
                </ul>
              </div>
            </div>
          </section>

          <section className="hspc-section">
            <div className="hspc-headline">
              <h2 style={{ margin: 0, fontWeight: "bold" }}>Results</h2>
              <div className="hspc-rule" />
            </div>
            <div className="hspc-card">
              <div className="hspc-metrics">
                <div className="hspc-metric" aria-label="Escalation speed">
                  <h4>🚀 60%</h4>
                  <p>faster escalation to specialist teams</p>
                </div>
                <div className="hspc-metric" aria-label="Claimant satisfaction">
                  <h4>✅ +3</h4>
                  <p>point improvement in claimant satisfaction scores</p>
                </div>
                <div className="hspc-metric" aria-label="Customer quote">
                  <h4>💬</h4>
                  <p>
                    “It’s like having another set of eyes reviewing every
                    claim.”
                  </p>
                </div>
                <div className="hspc-metric" aria-label="Time to value">
                  <h4>⏱️ &lt; 30 days</h4>
                  <p>Deployed; rapid time-to-value</p>
                </div>
              </div>
            </div>
          </section>

          <section className="hspc-section">
            <div className="hspc-headline">
              <h2 style={{ margin: 0, fontWeight: "bold" }}>Why It Matters</h2>
              <div className="hspc-rule" />
            </div>
            <div className="hspc-card">
              <p>
                Early visibility into high-severity potential improves triage,
                optimizes resource use, reduces payout volatility, and protects
                customer relationships.
              </p>
            </div>
          </section>

          <footer className="hspc-footer">
            © {year} Charlee.ai — Use Case 4: High Severity Potential Claims
          </footer>
        </main>
      </div>
    </div>
  );
};
